import { Component, OnInit } from '@angular/core';
import { quickPayModel } from '../../models/quickpay/quickpay.model';
import { sessionServices } from '../../services/session.services';
import { HttpTestService } from 'app/services/http.service';
import { AppSettings } from 'app/config/settings/app-settings';
import { signUpModel } from '../../models/signup/signup.model';
import { Constants } from 'app/config/settings/constants';

@Component({
	selector: 'app-connection-management',
	templateUrl: './connection-management.component.html',
	styleUrls: ['./connection-management.component.css']
})
export class ConnectionManagementComponent implements OnInit {

	public errorMsg: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public quickPayModel: quickPayModel = new quickPayModel;
	public connectionManagementData: any = "";
	public serviceOn: boolean = false;

	public isDisableCB: boolean = true;
	public isChecked: boolean = false;
	public disableButton: boolean = true;
	public isShowTermsCondnts: boolean = false;
	public viewpopupopen: boolean = false;
	public payableAmount: number;
	public isTermsCond: boolean = true;
	public consumerNo: number;
	public contractArray: Array<number> = [0, 1, 2];
	public activePanelList: Array<number> = this.contractArray;

	public postPaymentData = {
		"applicationNumber": null,
		"paymentType": null,
		"amount": null,
		"consumerId": null,
		"paymentChannelId": null,
		"gateway":null
	}
	public tabs: boolean[] = [true, false, false];
	public allUserData: any = [];
	public registeredUserData: any = null;
	public signUpModel: signUpModel = new signUpModel;
	public isHideLoadCalculator: boolean = true;
	loadListPopup: any[] = [{
		applianceId: null,
		applianceName: null,
		applianceWatt: null,
		applianceCount: null,

	}];
	bindData: any = {
		"mobileNumber": null,
		"aadharNumber": null,
		"panNumber": null,
		"additionalLoad": 0.00,
		"totalLoad": 0.00,
		"reducedLoad": 0.00,
		"newFirstName": null,
		"newLastName": null,
		"newTariff": null,
		"narration": null,
	}
	totalLoad: number = 0;
	isHideLoadVerify: boolean = false;
	isHideDetailsVerify: boolean = true;
	isHideTariffVerify: boolean = true;
	isLoadVerify: boolean = false;
	isDetailsVerify: boolean = false;
	isTariffVerify: boolean = false;
	isSubmitProceed: boolean = false;

	requestType: any = 1;
	requestTypeList: Array<Object> = [
		{ id: 1, name: "Load Enhancement" },
		{ id: 2, name: "Load Reduction" },
		{ id: 3, name: "Name Change" },
		{ id: 4, name: "Tariff Change" }
	];
	requestTypeSelected: any;

	tariffCategoryList: any[] = [];
	paymentTypeNo:any;
	fileAdhar: File = null;
	filePan: File = null;
	prevLoad:any = 0;
	submitSuccess:boolean = false;

	constructor(public session: sessionServices,
		public http: HttpTestService) {
	}

	ngOnInit() {
		this.getSession();
		this.getConsumerDetails();
		this.getTariffList();
		this.loadDetails();
		this.onChangeRequestType(1);
		this.tabs[0] = true;
		this.submitSuccess = false;
	}

	getSession = function () {
		this.sessionData = this.session.getSessionDetails();
		if (this.sessionData.consumerId || this.sessionData.consumerId != '' || this.sessionData.consumerId != undefined) {
			this.consumerNo = this.sessionData.consumerId;
			this.getConnectionManagementHistory();
		}
	}

	getTariffList = function () {
		this.serviceOn = true;
		this.http.getTariffList().subscribe(
			(data) => {
			  this.tariffCategoryList = data;
			  this.busySpinner.tarrifCatagoryListBusy = false;
			  this.updateBusySpinner();
			  this.serviceOn = false;
			},
			(error) => {
				this.serviceOn = false;
			});
	}

	getConnectionManagementHistory = function () {
		this.serviceOn = true;
		this.errorMsg = "";
		this.successMsg = "";
		this.http.getConnectionManagementHistory(this.consumerNo).subscribe(
			(success: any) => {
				if (success.status == 1) {
					this.connectionManagementData = success.response;
					this.serviceOn = false;
				} else {
					this.errorMsg = success.message;
					this.serviceOn = false;
				}
			}),
			(error) => {
				this.errorMsg = error;
				this.connectionManagementData = "";
				this.serviceOn = false;
			}
	}

	getPayableAmountProceed = function (dueAmount: string) {
		this.quickPayModel.paymentOpt = "BILLDESK";
		this.isDisableCB = false;
		this.isChecked = false;
		this.payableAmount = parseInt(dueAmount);
		this.viewpopupopen = true;
	}

	startPayment = function () {
		if (this.quickPayModel.paymentOpt == "BILLDESK") {
			this.billDeskPayment();
		} else if (this.quickPayModel.paymentOpt == "RAZORPAY") {
			this.payWithRazorpayGateway();
		} else if (this.quickPayModel.paymentOpt == "PAYTM") {
			this.paytmPayment();
		} else if (this.quickPayModel.paymentOpt == "OXIGEN") {
			this.oxigenPayment();
		}
	}

	payWithRazorpayGateway() {
		// let consumerNo: any;
		// if (this.quickPayModel.consumerId != null && this.quickPayModel.consumerId != "") {
		// 	consumerNo = this.quickPayModel.consumerId;
		// } else {
		// 	consumerNo = this.sessionData.consumerId;
		// }

		// this.billAmount = 100; // TODO: remove beore production
		//var paymentType = 3;
		var payChannelId = 1;
		//this.postPaymentData.consumerId = consumerNo;
		this.postPaymentData.paymentType = this.paymentTypeNo;
		this.postPaymentData.amount = this.payableAmount;
		this.postPaymentData.gateway = 2;
		this.postPaymentData.paymentChannelId = payChannelId;

		if(!this.postPaymentData.amount || this.postPaymentData.amount < 1) {
			this.errorMsg = 'Can not proceed with bill amount zero(0).';
			return false;
		}

		console.log('postPaymentData -> ',this.postPaymentData)
		// initiate payment request
		this.http.postPayEmd(this.postPaymentData).subscribe((data) => {
			if(data['orderNo'] == null) { this.errorMsg = 'Could not proceed with gateway, please try again later.'; return; }
			let orderNo: String = data['orderNo'];
			if(orderNo && orderNo.length > 0) {
				let options: any = {
					"key": Constants.rzp_key,
					"amount": (this.postPaymentData.amount * 100), /* amount to be passed as lowest currency unit */
					"name": "INDIA POWER",
					"description": "Payment",
					"image": "./assets/images/logo.jpg",
					"order_id": orderNo,
					"modal": {
						"escape": false
					},
					"prefill": {
						// "name": this.postPaymentData.consumerId,
						// "email": "gaurav.kumar@example.com",
						// "contact": "9999999999",
						// "method": 'card',
						// 'card[number]': finalObj.cardDetail.cardNumber,
						// 'card[expiry]': finalObj.cardDetail.cardExpDate,
						// 'card[cvv]': finalObj.cardDetail.cardCvv
					},
					"notes": {
					  "Consumer_Id": this.postPaymentData.consumerId
					},
					// "theme": {
					// 	"color": "#0d4371"
					// }
				};
				options.handler = ((response) => {
					options['payment_response_id'] = response.razorpay_payment_id;
					console.log(response);
					this.handleRazorpayResponse(response);
				});
				options.modal.ondismiss = (() => {
					//   this.loginService.SetLoader = false;
					console.log('on dismiss');
				});
				let rzp = new this.http.nativeWindow.Razorpay(options);
				rzp.open();
			} else {
				this.errorMsg = 'Order could not be created, please try again later.';
			}

		}, (error) => {
			this.errorMsg = error;
		}, () => {
			this.successMsg = "";
			this.serviceOn = false;
		});
		
	}

	handleRazorpayResponse(razorpayResponse) {
		this.http.postRazorpayResponse(razorpayResponse).subscribe((resp) => {
			if(resp['status'] === 'success') {
				this.successMsg = resp['paymentProcessingMessage'];
				setTimeout(() => { window.location.reload(); }, 5000);
				/* let paramText = "Payment is successful!&billPeriod=" + lastMonthInString + "&consumerId="
							+ consumerDetail.getTransactionId() + "&paymentAmount="
							+ String.valueOf(paymentMaster.getAmount()) + "0"
							+ "&dateOfTransaction="
							+ dateFormats1.format(paymentMaster.getDate())
							+ "&paymentGateway=BILLDESK_PAYMENT&paymentReference="
							+ razorpayPaymentResponse.getRazorpay_payment_id()
							+ "&status=Success&reason=Payment Successful!" */
			} else {
				this.errorMsg = resp['paymentProcessingMessage'];
			}
		});
	}

	oxigenPayment = function () {
		this.oxigenPaymentselect = true;
	}

	paytmPayment = function () {
		window.location.href = AppSettings.PAYTM_URL;
	}

	billDeskPayment = function () {
		this.disableButton = true;
		var paymentType = 4;
		var payChannelId = 1;
		this.postPaymentData.consumerId = this.consumerNo;
		this.postPaymentData.paymentType = paymentType;
		this.postPaymentData.amount = this.payableAmount;
		this.postPaymentData.paymentChannelId = payChannelId;

		this.http.postPayEmd(this.postPaymentData).subscribe(
			(success: any) => {
				this.initiatePaymentData = success.sourceSystem;
				window.location.href = AppSettings.BILLDESK_URL + "?msg=" + this.initiatePaymentData;
			},
			(error) => {
				this.errorMsg = error;
			},
			() => {
				this.successMsg = "";
			})
	}

	closePayOpt = function () {
		if (this.sessionData.sessionStarted == "true") {
			this.isHidePrepaid = false;
			this.isHidePostpaid = false;
		} else if (this.sessionData.sessionStarted == "false") {
			this.getConsumerDetails();
		}
		this.isHideConsumerDetails = true;
		this.viewpopupopen = false;
		this.isHideCancel = true;
		this.quickPayModel.paymentOpt = "";
	}

	showTermsCondtn = function () {
		if (this.isChecked) {
			this.disableButton = true;
			this.isShowTermsCondnts = false;
		} else {
			this.disableButton = false;
			this.isShowTermsCondnts = true;
		}
	}

	openTermsCondition = function () {
		this.isTermsCond = false;
	}

	cancelTermsCondtn = function () {
		this.isTermsCond = true;
	}

	tabChange = function (idx) {
		this.tabs.forEach((tab, i) => {
			this.tabs[i] = false;
		});
		this.tabs[idx] = true;
		console.log(this.tabs);
	}

	getConsumerDetails = function () {
		this.errorMsg = "";
		this.successMsg = "";
		this.http.getUserDetailsByConsNo(this.consumerNo).subscribe(
			(data) => {
				this.allUserData = data;
			},
			(error) => {
				this.errorMsg = error;
				this.allUserData = "";
			},
			() => {
				if (this.allUserData.name) {
					this.registeredUserData = this.allUserData;
					this.signUpModel.consumerMobile = this.allUserData.mobile;
					this.signUpModel.consumerEmail = this.allUserData.emailid;
				} else {
					this.registeredUserData = "";
				}
			});
	}

	clickAppliedLoad = function () {
		this.isHideLoadCalculator = false;
		// this.router.navigate(['/consumerBasicInfot'],{ skipLocationChange: false });
		document.getElementById("id1").style.display = "block";
		// this.isHideLink = false;

	}

	loadDetails = function () {
		this.http.getAllLoadData().subscribe(
			(data) => {
				this.loadListPopup = data;
			},
			(error) => {
				this.errorMsg = error;
			}, () => {
			})
	}

	closePopupDisagree = function () {
		document.getElementById("id1").style.display = "none";
	}

	valuechange = function (index, updatedCount) {
		this.totalLoad = 0;
		this.loadListPopup.forEach((listItem, i) => {
			if (i == index)
				listItem.applianceCount = updatedCount;

			this.totalLoad += (listItem.applianceWatt * (typeof listItem.applianceCount == 'undefined' ? 0 : listItem.applianceCount) / 1000);

			if (this.requestType == 1) {
				this.bindData.additionalLoad = this.totalLoad.toFixed(2);
				this.bindData.totalLoad = (this.totalLoad + 3.3).toFixed(2);
			} else {
				this.bindData.reducedLoad = this.totalLoad.toFixed(2);
				this.bindData.totalLoad = (3.3 - this.totalLoad).toFixed(2);
				if (this.bindData.totalLoad <= 0) {
					this.totalLoad = 0;
					this.bindData.totalLoad = 0
				}
			}

			if (this.totalLoad > 0)
				this.isHideLoadVerify = true;
			else
				this.isHideLoadVerify = false;
		});
	}

	loadVerify = function () {
		this.isLoadVerify = true;
	}

	detailsVerify = function () {
		this.isDetailsVerify = true;
	}

	tariffVerify= function () {
		this.isTariffVerify = true;
	}

	cancelLoadVerify = function () {
		this.isLoadVerify = false;
	}

	acceptedLoadVerify = function () {
		this.isHideLoadVerify = false;// hide "Verify Load" button
		this.isLoadVerify = false;//close modal
		this.isSubmitProceed = true; //visible "Submit" button
	}

	cancelDetailsVerify = function () {
		this.isDetailsVerify = false;
	}

	acceptedDetailsVerify = function () {
		this.isHideDetailsVerify = false;// hide "Verify Load" button
		this.isDetailsVerify = false;//close modal
		this.isSubmitProceed = true; //visible "Submit" button
	}

	cancelTariffVerify= function () {
		this.isTariffVerify = false;
	}

	acceptedTariffVerify = function () {
		this.isHideTariffVerify = false;// hide "Verify Load" button
		this.isTariffVerify = false;//close modal
		this.isSubmitProceed = true; //visible "Submit" button
	}

	onChangeRequestType = function (value: any) {
		var element: any = this.requestTypeList.filter(r => r["id"] == value);
		this.requestTypeSelected = element[0].name;

		console.log('requestTypeSelected -> ',this.requestTypeSelected)
		if(this.requestTypeSelected == 'Load Enhancement'){
			this.paymentTypeNo = 5
		}else if(this.requestTypeSelected == 'Load Reduction'){
			this.paymentTypeNo = 6
		}else if(this.requestTypeSelected == 'Name Change'){
			this.paymentTypeNo = 7
		}else{
			this.paymentTypeNo = 8
		}
	}

	submit = function () {
		let fd = new FormData();
		//this.fileAdhar==null?fd.append('adhar',null,null):fd.append('adhar', this.fileAdhar, this.fileAdhar.name);
		//this.filePan==null?fd.append('pan',null,null):fd.append('pan', this.filePan, this.filePan.name);
		if(this.fileAdhar){fd.append('adhar', this.fileAdhar, this.fileAdhar.name);}
		if(this.filePan){fd.append('pan', this.filePan, this.filePan.name);}
		
		fd.append("consumerId", this.registeredUserData.consumerNo)
		fd.append("requestTypeId", this.requestType)
		fd.append("previousLoad", this.registeredUserData.sanctionLoad)
		fd.append("additionalLoad", this.bindData.additionalLoad)
		fd.append("reducedLoad", this.bindData.reducedLoad)
		fd.append("newFirstName", this.bindData.newFirstName)
		fd.append("newLastName", this.bindData.newLastName)
		fd.append("previousTariff", this.registeredUserData.tariff)
		fd.append("newTariff", this.bindData.newTariff)
		fd.append("mobileNo", this.bindData.mobileNumber)
		fd.append("reason", this.bindData.narration)
		fd.append("previousTariffCategory",this.registeredUserData.tariff)
		fd.append("areaCategoryType", this.registeredUserData.addinfo4)
		//fd.append("connectionType",this.registeredUserData.addinfo3)
		fd.append("connectionType",this.registeredUserData.addinfo2)
		this.registeredUserData.addinfo3==""?fd.append("powerSupply", ""):fd.append("powerSupply", this.registeredUserData.addinfo3);
		fd.append("phaseId", this.registeredUserData.addinfo5)
		fd.append("supplyPurposeType", this.registeredUserData.addinfo1)
		fd.append("mouzaZone",this.registeredUserData.businessAreaText)
		fd.append("name", this.registeredUserData.name)
		fd.append("address1", this.registeredUserData.address1)
		fd.append("address2", this.registeredUserData.address2)
		fd.append("address3", this.registeredUserData.address3)
		fd.append("address4", this.registeredUserData.address4)
		fd.append("newTariffCategory", this.bindData.newTariff)
		fd.append("newPanNo", this.bindData.panNumber)
		fd.append("newAadharNo", this.bindData.aadharNumber)
		fd.append("city", this.registeredUserData.city)
		fd.append("pincode", this.registeredUserData.pincode)
		fd.append("state", this.registeredUserData.state)
		fd.append("emailid", this.registeredUserData.emailid)
		fd.append("region", this.registeredUserData.region)

		console.log(fd)
		
		this.http.saveConnectionManagementDetails(fd).subscribe(
			(success: any) => {
				if (success.status == 1) {
					this.successMsg = success.message;
					this.serviceOn = false;
					this.submitSuccess = true;
				} else {
					this.errorMsg = success.message;
					this.serviceOn = false;
				}
			},
			(error) => {
				this.errorMsg = error;
				this.serviceOn = false;
			}
		);
	}

	reset = function () {
		this.isDisableCB = true;
		this.isChecked = false;
		this.disableButton = true;
		this.isShowTermsCondnts = false;
		this.isHideLoadCalculator = true;
		this.isHideLoadVerify = false;
		this.isLoadVerify = false;
		this.isSubmitProceed = false;
		this.bindData.mobileNumber = null;
		this.bindData.aadharNumber = null;
		this.bindData.panNumber = null;
		this.bindData.newFirstName = null;
		this.bindData.newLastName = null;
		this.bindData.narration = null;
		this.bindData.newTariff = null;
		this.bindData.additionalLoad = 0;
		this.bindData.totalLoad = 0;
		this.bindData.reducedLoad = 0;
	}

	onSelectAdhar(event){
		if (event.target.files.length > 0) {
			if (event.target.files[0].size > 1024*1024) {
			  this.errorMsg = "File size must not exceed 1 MB"
			  event.target.value = null;
			}
			else { 
				this.fileAdhar = <File>event.target.files[0]; 
				this.errorMsg = ""
			}
		  }
	}

	onSelectPan(event){
		if (event.target.files.length > 0) {
			if (event.target.files[0].size > 1024*1024) {
			  this.errorMsg = "File size must not exceed 1 MB"
			  event.target.value = null;
			}
			else { 
				this.filePan = <File>event.target.files[0]; 
				this.errorMsg = ""
			}
		  }
	}

	loadChange(type:any){
		this.bindData.totalLoad = 0;
		//this.isHideLoadVerify = false;
		var str = this.registeredUserData.sanctionLoad
		var length = str.length
		this.prevLoad = str.slice(0, length-4)
		
		if(type=='reduce' && this.bindData.reducedLoad>0){
			this.bindData.totalLoad = Number(this.prevLoad) - Number(this.bindData.reducedLoad)
		}else if(type=='add' && this.bindData.additionalLoad>0){
			this.bindData.totalLoad = Number(this.prevLoad) + Number(this.bindData.additionalLoad)
		}
		console.log('total load -> ',this.bindData.totalLoad)

		// if(this.bindData.totalLoad>0){
		// 	this.isHideLoadVerify = true;
		// }
	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/connection-management/connection-management.component.ts